import { connect } from 'react-redux';
import CalendarView from './index'
import moment from 'moment'

const mapStateToProps = (state, props) => {
    return {
	eventsDates: state.events.list ? state.events.list.map((e) => moment(e.event_on).format('YYYY/MM/DD')) : null
    }
}

const mapDispatchToProps = (dispatch, state) => {
  
    return {

    }
}

const CalendarContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(CalendarView);




export default CalendarContainer;



// WEBPACK FOOTER //
// ./src/components/Calendar/Container.js